import { Box } from '@mui/material';
import React, { FC, useState } from 'react';
import { Typography700 } from 'views/common/components';
import Typography500 from 'views/common/components/UI/Typography500';
import { PlanCardList } from 'views/rebranded-module/common/components/UI/PlanCardList';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import StyledBox from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/MembershipPlansSection/MembershipPlansSection.styles';
import dynamic from 'next/dynamic';
import {  useSelector } from 'redux/app/store';

const MembershipStatusOverlayWrapper = dynamic(() => import(
  'views/rebranded-module/membership-module/MembershipLandingViewV2/components'
).then((file) => file.MembershipStatusOverlayWrapper));

const MembershipPlansSection: FC<any> = (props) => {
  const content = useContent();
  const { plansData } = props;
  const appState = useSelector((state) => state.globalData.appState);
  
   const [
         openMembershipStatusOverlay,
         setOpenMembershipStatusOverlay,
       ] = useState(false);
     
       const handleMembershipStatusOverlayOpen = () => {
         setOpenMembershipStatusOverlay(true);
       };
     
       const handleMembershipStatusOverlayClose = () => {
         setOpenMembershipStatusOverlay(false);
       };
      const handleJoinNowClick = () => {
          handleMembershipStatusOverlayOpen();
      };
  return (
    <StyledBox>
      <Box mb={10} textAlign="center" className="MPSWrapper">
        <Typography700 variant="h2">
          {content.MembershipLandingPage.membershipPlansHeader}
        </Typography700>
        <Typography500 variant="body1" pt={3} color="text.secondary">
          {content.MembershipLandingPage.membershipPlansSubheader}
        </Typography500>
      </Box>
      <PlanCardList
        plansData={plansData}
        content={content}
        handleJoinNowClick={
           appState.user_membership
           && !['inactive', 'cancelled'].includes(appState.user_membership.status?.sym_id)
                ? handleJoinNowClick
            : null
        }
      />
         {openMembershipStatusOverlay && (
            <MembershipStatusOverlayWrapper
              openMembershipStatusOverlay={
                openMembershipStatusOverlay
              }
              handleMembershipStatusOverlayClose={
                handleMembershipStatusOverlayClose
              }
            />
          )}
    </StyledBox>
  );
};

export { MembershipPlansSection };
